import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';
import { preparePhone } from '@alfa-bank/site-form-utils/decorators/prepare-phone';

import { requestConfirmationCode } from '../../../../helpers/api';
import type { TAction } from '../../models';
import { countTime } from '../../helpers/count-time';
import type { IApiErrorResponse } from '../../../../helpers/api/models';
import { retryIdentificationViews, retryIdentificationStatuses } from '../../config';
import { handleError } from '../../helpers';

export const requestCode: TAction = async ({ form: { change, getState, submit }, values }) => {
    try {
        const { phone, prodType } = values;

        if (!phone || !getState().valid) {
            submit();

            return;
        }

        change('privatePhone', preparePhone(phone));

        const {
            data: { availableSignMethods },
        } = await requestConfirmationCode(getNumbersFromStr(phone), prodType);

        change(
            'confirmation.countdownDuration',
            countTime(availableSignMethods.newCodeRequestTime)
        );
        change('confirmation.state', 'INITIAL');
        change('authenticationStep', 'checkConfirmationCode');
        change('authenticationStatus', 'processing');
    } catch (error) {
        handleError(
            error as IApiErrorResponse,
            change,
            getState,
            retryIdentificationViews,
            retryIdentificationStatuses
        );
    }
};
